<!--
 * @Description  : 视频下载弹窗
 * @Author       : 王帅
 * @Date         : 2025-12-15 16:36:02
 * @LastEditors  : 王帅
 * @LastEditTime : 2025-12-19 15:18:18
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\camera-error-records\dialog-download.vue
-->
<template>
	<el-dialog :visible.sync="dialogVisible" title="视频下载" width="1000px" @close="handleClose">
		<div class="text-right mb10">
			<el-button type="success" plain @click="batchDownload">批量下载</el-button>
		</div>
		<vxe-table
			size="small"
			ref="xTable"
			border
			resizable
			:row-config="{ keyField: 'id', isCurrent: true, isHover: true }"
			:checkbox-config="{ reserve: true }"
			:data="tableData"
			height="450"
			@checkbox-all="handleSelectAll"
			@checkbox-change="handleSelect"
		>
			<vxe-table-column type="checkbox" title="" align="center" width="80"></vxe-table-column>
			<vxe-table-column type="seq" title="序号" align="center" width="100"></vxe-table-column>
			<vxe-table-column field="fileName" min-width="400px" show-overflow-tooltip title="视频名称" align="left"></vxe-table-column>
			<vxe-table-column width="120" align="left" show-overflow-tooltip title="操作">
				<template slot-scope="{ row }">
					<el-button type="success" size="mini" round icon="el-icon-download" @click="videoDownload(row)">下载</el-button>
				</template>
			</vxe-table-column>
		</vxe-table>
		<el-pagination
			size="small"
			@size-change="sizeChange"
			@current-change="currentChange"
			:current-page="pageObj.currentPage"
			:page-sizes="pageObj.pageList"
			:page-size="pageObj.pageSize"
			layout="total, sizes, prev, pager, next, jumper"
			:total="pageObj.total"
			class="tc mt10 mb10"
		>
		</el-pagination>
	</el-dialog>
</template>

<script>
import * as API from '@/api/modules/fieldManagement'
export default {
	name: '',
	data() {
		return {
			dialogVisible: false,
			currentRow: {},
			tableData: [], // 表格数据
			pageObj: { currentPage: 1, pageSize: 10, total: 0, pageList: [10, 20, 50, 100] },
			selectData: []
		}
	},
	methods: {
		// 打开弹窗
		dialogOpen(row) {
			this.currentRow = this.$utils.clone(row, true)
			this.dialogVisible = true
			this.getTableData()
		},
		// 获取下载表格
		getTableData() {
			const params = {
				id: this.currentRow.id,
				tenantId: this.currentRow.tenantId,
				videoId: this.currentRow.videoId,
				current: this.pageObj.currentPage,
				size: this.pageObj.pageSize
			}
			API.getVideoDownPage(params)
				.then((res) => {
					this.tableData = res.data.records || []
					this.pageObj.total = Number(res.data.total || 0)

					if (this.selectData.length > 0) {
						// 回显已经勾选的
						this.selectData.map((i) => {
							const find = this.tableData.find((x) => x.id === i.id)
							!!find && this.$refs.xTable.setCheckboxRow(find, true)
						})
					}
				})
				.catch((err) => {})
		},

		// 切换显示条数
		sizeChange(val) {
			this.pageObj.pageSize = val
			this.getTableData()
		},

		// 切换当前页码
		currentChange(val) {
			this.pageObj.currentPage = val
			this.getTableData()
		},

		// 手动勾选触发
		handleSelect({ checked, row }) {
			const findIndex = this.selectData.findIndex((i) => i.id === row.id)
			// 已存在 取消勾选 删除掉
			if (findIndex > -1 && !checked) {
				this.selectData.splice(findIndex, 1)
			}
			// 不存在 勾选上 加入数组
			if (findIndex < 0 && checked) {
				this.selectData.push(row)
			}
		},

		// 勾选全部
		handleSelectAll({ checked }) {
			this.tableData.map((x) => {
				const findIndex = this.selectData.findIndex((i) => i.id === x.id)
				// 已存在 取消勾选 删除掉
				if (findIndex > -1 && !checked) {
					this.selectData.splice(findIndex, 1)
				}
				// 不存在 勾选上 加入数组
				if (findIndex < 0 && checked) {
					this.selectData.push(x)
				}
			})
		},

		// 批量下载
		batchDownload() {
			if (this.selectData.length === 0) {
				this.$message.warning('请选择要下载的视频！')
				return
			}
			this.selectData.map((i) => {
				const iframe = document.createElement('iframe')
				iframe.style.display = 'none' // 防止影响页面
				iframe.style.height = 0
				iframe.src = i.videoUrl + `?name=${i.fileName}`
				document.body.appendChild(iframe)
				setTimeout(() => {
					iframe.remove()
				}, 1000)
			})
		},

		// 视频下载--单个
		videoDownload(data) {
			let url = data.videoUrl + `?name=${data.fileName}`
			window.open(url, '_blank')
		},

		handleClose() {
			this.dialogVisible = false
			this.currentRow = {}
			this.tableData = []
			this.pageObj = { currentPage: 1, pageSize: 10, total: 0, pageList: [10, 20, 50, 100] }
		}
	},
	computed: {}
}
</script>
<style scoped lang="less"></style>
